import React, { useState } from "react";
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";

const navLinks = [
  { to: "/", label: "Kezdőlap", testId: "nav-link-home", anchor: null },
  { to: "/hogyan-mukodik", label: "Hogyan működik?", testId: "nav-link-how", anchor: "#hogyan-mukodik" },
  { to: "/tortenetunk", label: "Történetünk", testId: "nav-link-story", anchor: null },
  { to: "/termek", label: "GrowBag", testId: "nav-link-product", anchor: "#growbag" },
  { to: "/kapcsolat", label: "Kapcsolat", testId: "nav-link-contact", anchor: null },
];

export default function Layout() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  React.useEffect(() => setOpen(false), [location.pathname]);

  React.useEffect(() => {
    if (!location.hash) window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname, location.hash]);

  React.useEffect(() => {
    if (location.pathname === "/" && location.hash) {
      setTimeout(() => {
        const el = document.querySelector(location.hash);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 80);
    }
  }, [location.pathname, location.hash]);

  const handleNav = (e, l) => {
    const isHome = location.pathname === "/";
    if (isHome && l.anchor) {
      e.preventDefault();
      const el = document.querySelector(l.anchor);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else if (!isHome && l.anchor) {
      e.preventDefault();
      navigate(`/${l.anchor}`);
    }
  };

  const scrollToSubscribe = (e) => {
    if (location.pathname === "/") {
      e.preventDefault();
      const el = document.getElementById("feliratkozas");
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const isActive = (l) => {
    if (l.to === "/") return location.pathname === "/" && !location.hash;
    return location.pathname === l.to;
  };

  return (
    <div className="min-h-screen flex flex-col">
      <header className="site-header">
        <div className="container-gb">
          <Link to="/" data-testid="nav-logo-link" className="logo">
            <span className="logo-word">GROWBAG</span>
            <span className="mono" style={{ color: "var(--muted)" }}>XVII.</span>
          </Link>
          <nav className="nav-desktop">
            {navLinks.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={l.testId}
                className={isActive(l) ? "active" : ""}
                onClick={(e) => handleNav(e, l)}
              >
                {l.label}
              </Link>
            ))}
          </nav>
          <Link
            to="/#feliratkozas"
            onClick={scrollToSubscribe}
            className="btn btn-primary header-cta"
            data-testid="nav-cta-subscribe"
          >
            Érdekel az első GrowBag <span className="arrow">→</span>
          </Link>
          <button
            type="button"
            className="menu-btn"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
            aria-label="Menü"
          >
            <span></span>
          </button>
        </div>
        {open && (
          <div className="mobile-menu">
            {navLinks.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className="m-link"
                onClick={(e) => handleNav(e, l)}
                data-testid={`mobile-${l.testId}`}
              >
                {l.label}
              </Link>
            ))}
            <Link to="/#feliratkozas" className="btn btn-primary" onClick={scrollToSubscribe} data-testid="mobile-nav-cta-subscribe">
              Érdekel az első GrowBag <span className="arrow">→</span>
            </Link>
          </div>
        )}
      </header>

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="site-footer-gb">
        <div className="container-gb">
          <p className="footer-word">GROWBAG</p>
          <div className="footer-grid">
            <div>
              <p className="mono" style={{ color: "var(--kraft)", marginBottom: 10 }}>● A HELYI KÖRFORGÁS</p>
              <p style={{ color: "var(--muted-on-dark)", maxWidth: "30em" }}>
                Helyben keletkezik. Helyben készül. Helyben nő tovább. Egy kis ötlet Budapest XVII. kerületéből.
              </p>
            </div>
            <ul className="footer-links">
              {navLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} onClick={(e) => handleNav(e, l)}>{l.label}</Link>
                </li>
              ))}
            </ul>
            <ul className="footer-links">
              <li><Link to="/adatkezeles">Adatkezelési tájékoztató</Link></li>
              <li><Link to="/felhasznalasi-feltetelek">Felhasználási feltételek</Link></li>
              <li><a href="https://instagram.com" target="_blank" rel="noopener noreferrer">Instagram</a></li>
            </ul>
          </div>
          <div style={{ marginTop: 56, display: "flex", flexWrap: "wrap", justifyContent: "space-between", gap: 12, color: "var(--muted-on-dark)", fontSize: ".85rem" }}>
            <span>© {new Date().getFullYear()} GrowBag · Budapest XVII. kerület</span>
            <span className="mono">Helyi körforgás, zsákban.</span>
          </div>
        </div>
      </footer>
    </div>
  );
}
